// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Divider,
    Fab,
} from '@mui/material'
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { useToast } from '../../../components/ToastProvider';

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [searchParams] = useSearchParams();
    const pclass:any = searchParams.get('class') || '';
    const currentTab = searchParams.get('tab') || '1';

    // ** State
    const [tabs, setTabs] = useState<string>(currentTab)    
    const [listData, setListData] = useState<any[]>([])

    // array map
    const makloonMap: Record<number, string> = {
        12604000001: "JASA MAKLOON PRINTING",
        12604000002: "JASA MAKLOON BORDIR",
        12604000003: "JASA MAKLOON JAHIT",
        12604000004: "JASA MAKLOON PACKING",
        12604000005: "JASA MAKLOON LAINNYA",
    };

    const getMakloonName = (id: any): any => {
        return makloonMap[id] ?? "UNKNOWN";
    };

    useEffect(() => {
        getData(currentTab)
    }, [searchParams])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        showToast("Loading...", "loading");
        const url = apiUrl.apiUrl + '/purchasing/master-makloon/list'

        axios
            .get(url, {
                params: {
                    mode:mode,
                    barang_class_id:pclass
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        navigate(`?tab=${newValue}&class=${pclass}`);
        getData(newValue)
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title={`${getMakloonName(pclass)}`} />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => {
                                if(tabs=="1"){
                                    navigate('/purchasing/master-makloon/add?class='+pclass)
                                }else if(tabs=="2"){
                                    navigate('/purchasing/purchase-request/add?class='+pclass)
                                }else if(tabs=="3"){
                                    navigate('/purchasing/purchase-order')
                                }else if(tabs=="4"){
                                    navigate('/purchasing/good-receipt')
                                }
                            }}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='1' label='Master Data' />
                            <Tab value='2' label='PR Makloon' />
                            <Tab value='3' label='PO Makloon' />
                            <Tab value='4' label='GR Makloon' />
                        </TabList>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} hiddenColumns={['is_aktif']}
                            rowStyleRules={[
                                { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                            ]} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} hiddenColumns={['is_aktif']} 
                            rowStyleRules={[
                                { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                            ]} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <MsiDatagrid array={listData} hiddenColumns={['is_aktif']}
                            rowStyleRules={[
                                { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                            ]} />
                        </TabPanel>
                        <TabPanel value='4'>
                            <MsiDatagrid array={listData} hiddenColumns={['is_aktif']}
                            rowStyleRules={[
                                { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                            ]} />
                        </TabPanel>
                    </TabContext>
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}